import { render, staticRenderFns } from "./CenterBoard.vue?vue&type=template&id=1749cb82&scoped=true"
import script from "./CenterBoard.vue?vue&type=script&lang=js"
export * from "./CenterBoard.vue?vue&type=script&lang=js"
import style0 from "./CenterBoard.vue?vue&type=style&index=0&id=1749cb82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1749cb82",
  null
  
)

export default component.exports